export const TOGGLE_SIDEBAR_COLLAPSED = '@@InspectioLayout/ToggleSidebarCollapsed';
export const SET_SIDEBAR_WIDTH = '@@InspectioLayout/SetSidebarWidth';
export const SET_RIGHT_SIDEBAR_WIDTH = '@@InspectioLayout/SetRightSidebarWidth';
export const SET_SIDEBYSIDE_WIDTH = '@@InspectioLayout/SetSideBySideWidth';
export const SET_SIDEBYSIDE_CELL = '@@InspectionLayout/SetSideBySideCell';
export const SET_CODY_CONSOLE_HEIGHT = '@@InspectioLayout/SetCodyConsoleHeight';
export const TOGGLE_SIDEBAR_DIVIDER = '@@InspectioLayout/ToggleSidebarDivider';
export const TOGGLE_SIDEBAR_EDITOR = '@@InspectioLayout/ToggleSidebarEditor';
